"use strict";

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SskySimpleTable = void 0;

const material_1 = require("@mui/material");

const react_1 = __importDefault(require("react"));

const SskyTableCell_1 = __importDefault(require("../SskyTableCell"));

const StyledTableRow = (0, material_1.styled)(material_1.TableRow, {
  shouldForwardProp: prop => prop !== "rowHeight"
})(({
  rowHeight
}) => ({
  [`&.${material_1.tableRowClasses.root}`]: {
    height: rowHeight
  }
}));
const StyledTableCell = (0, material_1.styled)(material_1.TableCell)({
  [`&.${material_1.tableCellClasses.root}`]: {
    fontSize: "12px"
  }
});
const StyledPaper = (0, material_1.styled)(material_1.Paper, {
  shouldForwardProp: prop => prop !== "backgroundColor" && prop !== "disabled"
})(({
  backgroundColor,
  disabled
}) => ({
  [`&.${material_1.paperClasses.root}`]: {
    width: "100%",
    overflowX: "auto",
    boxShadow: "none",
    backgroundColor: disabled ? "#f3f3f3" : backgroundColor
  }
}));
const StyledBigTableRow = (0, material_1.styled)(material_1.TableRow, {
  shouldForwardProp: prop => prop !== "rowHeight"
})(({
  rowHeight
}) => ({
  [`&.${material_1.tableRowClasses.root}`]: {
    height: rowHeight + 8
  }
}));

const SskySimpleTable = props => {
  const renderHeaders = () => {
    return props.headers.map(header => {
      return react_1.default.createElement(SskyTableCell_1.default, {
        key: header.id,
        numeric: header.numeric,
        "data-testid": header.dataTestId || `testId-${header.id}-headerCell`
      }, header.value);
    });
  };

  const renderData = () => {
    return props.data.map(row => {
      return react_1.default.createElement(StyledTableRow, {
        key: row.id,
        rowHeight: props.rowHeight,
        "data-testid": row.dataTestId || `testId-${row.id}-tableRow`
      }, props.headers.map(cell => {
        const properties = row[cell.id];

        if (properties) {
          const {
            span,
            value
          } = properties;
          return react_1.default.createElement(StyledTableCell, {
            key: cell.id,
            align: cell.numeric ? "right" : "inherit",
            colSpan: span || 1,
            padding: "normal",
            "data-testid": cell.dataTestId || `testId-${cell.id}-tableCell`
          }, value);
        }
      }));
    });
  };

  return react_1.default.createElement(StyledPaper, {
    className: props.className,
    backgroundColor: props.backgroundColor,
    disabled: props.disabled
  }, react_1.default.createElement(material_1.Table, {
    "data-testid": props.dataTestId
  }, props.showHeaders && react_1.default.createElement(material_1.TableHead, null, react_1.default.createElement(StyledBigTableRow, {
    rowHeight: props.rowHeight
  }, renderHeaders())), react_1.default.createElement(material_1.TableBody, null, renderData())));
};

exports.SskySimpleTable = SskySimpleTable;
SskySimpleTable.defaultProps = {
  backgroundColor: "#fff",
  rowHeight: 48,
  showHeaders: true,
  underline: true
};
exports.default = react_1.default.memo(SskySimpleTable);